import ReactDatePicker from 'react-datetime';
import React from 'react';

export default class DateTimePicker extends React.PureComponent {

    render() {
        return <ReactDatePicker {...this.props} />;
    }
}
